import { render, staticRenderFns } from "./Prestige.vue?vue&type=template&id=135fa6c8&scoped=true&"
import script from "./Prestige.vue?vue&type=script&lang=js&"
export * from "./Prestige.vue?vue&type=script&lang=js&"
import style0 from "./Prestige.vue?vue&type=style&index=0&id=135fa6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fa6c8",
  null
  
)

export default component.exports